<div class="forecast-content">
  <div class="forecast-section">
    <msf-select
      [(model)]="selectedDataSource"
      (selectItem)="onDataSourceChange()"
      [options]="dataSourceOptions"
      [optionLabel]="'names'"
      [optionValue]="'id'"
      [width]="'200px'"
    ></msf-select>

    <div class="forecast-container">
      <div class="forecast-navigation prev" *ngIf="showForecastPrev" (click)="scrollForecast('prev')">
        <i class="pi pi-chevron-left"></i>
      </div>
      <div class="forecast-navigation next" *ngIf="showForecastNext" (click)="scrollForecast('next')">
        <i class="pi pi-chevron-right"></i>
      </div>
      <div class="forecast-days" #forecastScroll (scroll)="onForecastScroll()">
        <div *ngFor="let day of forecastDays" class="forecast-day">
          <div class="forecast-day-container">
            <div class="day-weather-box">
              <div class="day-weather-icon">
                <img [src]="day.iconPath" class="weather-condition-icon" alt="Weather">
              </div>
              <div class="day-date">{{ day.date }}</div>
            </div>
          </div>

          <div class="day-temp">
            <span class="temp-min">{{ day.tempMin }}°</span>
            <span>/</span>
            <span class="temp-max">{{ day.tempMax }}°</span>
          </div>
          <div class="day-condition">{{ day.condition }}</div>
          <div class="day-details">
            <div class="detail-item">
              <span class="detail-label">{{ 'PRECIPITATION' | translate }}</span>
              <span class="detail-value">{{ day.precipitation }} {{'gis.unit.mm' | translate}}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">{{ 'HUMIDITY' | translate }}</span>
              <span class="detail-value">{{ day.humidity }}%</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">{{ 'WIND_SPEED' | translate }}</span>
              <span class="detail-value">{{ day.windSpeed }} {{'gis.unit.ms' | translate}}</span>
            </div>
            <div class="detail-item wind-direction" [style.--wind-direction]="day.windDirection + 'deg'">
              <span class="detail-label">{{ 'WIND_DIRECTION' | translate }}</span>
              <span class="detail-value">{{ day.windDirection }}°</span>
            </div>
          </div>
        </div>
      </div>

      <!-- No forecast data message -->
      <div *ngIf="(!forecastDays || forecastDays.length === 0) && !isLoading" class="no-forecast-data">
        <div class="no-data-message">
          <i class="pi pi-info-circle"></i>
          <span>{{ 'NO_FORECAST_DATA_AVAILABLE' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="loading-overlay" *ngIf="isLoading">
  <div class="spinner"></div>
</div>
